<div class="c-form-field c-form-field--d mb-5" [class.is-required]="isRequired">
  <div class="d-flex">
    <span class="c-form-field__label mr-6">
      {{ label }}
    </span>
    <button type="button" p500-ui-circled-button size="small" color="primary" (click)="createField()" class="c-form-field__add-icon">
      <p500-ui-icon name="controls-plus"></p500-ui-icon>
    </button>
  </div>
</div>

<ng-container *ngFor="let control of formArray.controls; let i = index; trackBy: trackByFn">
  <div class="row align-items-center mb-8">
    <div class="col">
      <p500-ui-text-field
        placeholder="### . ### . ### . ###"
        [formControl]="control"
        [errorMessage]="message"
        [hint]="hint"
        [disabled]="isDisabled"
      ></p500-ui-text-field>
    </div>
    <div *ngIf="!isRequired || i > 0 || formArray.controls.length > 1" class="col col-auto">
      <button class="c-form-field--remove-button" (click)="deleteField(i)">
        <p500-ui-icon name="bin"></p500-ui-icon>
      </button>
    </div>
  </div>
</ng-container>
